import Text from '@ingka/text';
import React from 'react';

export default (props: React.ComponentProps<typeof Text>) => (
    <Text prefix="list-ingka-" {...props} />
);
